var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2DollarPaymentLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3H13V12H1V3ZM7 5.25C7.53043 5.25 8.03914 5.48705 8.41421 5.90901C8.78929 6.33097 9 6.90326 9 7.5C9 8.09674 8.78929 8.66903 8.41421 9.09099C8.03914 9.51295 7.53043 9.75 7 9.75C6.46957 9.75 5.96086 9.51295 5.58579 9.09099C5.21071 8.66903 5 8.09674 5 7.5C5 6.90326 5.21071 6.33097 5.58579 5.90901C5.96086 5.48705 6.46957 5.25 7 5.25ZM3.66667 4.5C3.66667 4.89782 3.52619 5.27936 3.27614 5.56066C3.02609 5.84196 2.68696 6 2.33333 6V9C2.68696 9 3.02609 9.15804 3.27614 9.43934C3.52619 9.72064 3.66667 10.1022 3.66667 10.5H10.3333C10.3333 10.1022 10.4738 9.72064 10.7239 9.43934C10.9739 9.15804 11.313 9 11.6667 9V6C11.313 6 10.9739 5.84196 10.7239 5.56066C10.4738 5.27936 10.3333 4.89782 10.3333 4.5H3.66667Z",
    fill: "#240b3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2DollarPaymentLink);
export default __webpack_public_path__ + "static/media/v2-dollar-payment-link.319dc12e86a35e8a5046623af8d2600c.svg";
export { ForwardRef as ReactComponent };